import moment from 'moment';
import './moment-locales';

export const initMoment = lng => {
  if (lng === 'no') {
    lng = 'nb';
  }
  if (lng === 'zh') {
    lng = 'zh-cn';
  }
  moment.locale(lng);
};
